import { render } from "./PaymentSource.vue?vue&type=template&id=0afd945e&ts=true"
import script from "./PaymentSource.ts?vue&type=script&lang=ts&external"
export * from "./PaymentSource.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__